import axios from "axios";

export function requestWasCanceled(error) {
	return axios.isCancel(error);
}

export class CancellableRequest {
	constructor() {
		this.currentCancelToken = null;
		this.compareCancelToken = null;
	}

	/**
	 * Cancel the current or compare request that is already being send.
	 */
	cancel(isCompare = false) {
		if (isCompare)
			this._cancelCompareRequest();
		else {
			// only when canceling the current request cancel the compare request
			this._cancelCurrentRequest();
			this._cancelCompareRequest();
		}
	}

	/**
	 * When canceled triggers the catch block of the promise
	 * with the message string "CANCELED_CALL"
	 */
	_cancelCurrentRequest() {
		if (this.currentCancelToken) {
			this.currentCancelToken("CANCELED_CALL");
			this.currentCancelToken = null;
		}
	}

	/**
	 * When canceled triggers the catch block of the promise
	 * with the message string "CANCELED_COMPARE_CALL"
	 */
	_cancelCompareRequest() {
		if (this.compareCancelToken) {
			this.compareCancelToken("CANCELED_COMPARE_CALL");
			this.compareCancelToken = null;
		}
	}

	generateCancelToken(isCompare = false) {
		return new axios.CancelToken((canceltoken) => {
			if (isCompare)
				this.compareCancelToken = canceltoken;
			else
				this.currentCancelToken = canceltoken;

		});
	}
}

export const performanceGraphDataRequest = new CancellableRequest(),
	wastePerGuestRequest = new CancellableRequest(),
	wasteWeightCostRequest = new CancellableRequest(),
	categoryOverviewRequest = new CancellableRequest(),
	wastePerGuestPerServiceTimeRequest = new CancellableRequest(),
	trashEventsRequest = new CancellableRequest(),
	trashEventStarRequest = new CancellableRequest(),
	trashEventNoteRequest = new CancellableRequest(),
	trashEventReportRequest = new CancellableRequest(),
	averageWastePerGuestRequest = new CancellableRequest(),
	averageWastePerGuestPerDayRequest = new CancellableRequest(),
	edibleVsInedibleRequest = new CancellableRequest(),
	defaultGuestCountCheckRequest = new CancellableRequest();
